module.exports = __webpack_public_path__ + "static/media/uber2.1b7e7a3c.jpg";